module.exports = __webpack_public_path__ + "static/media/player.927ce8af.png";